// src/services/staffApi.js
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8001';

// ─── Client Requests (fuel + maintenance) ────────────────────────────────────
// Source: ClientRequestsView.jsx
export const getAllClientRequests = (params = {}) =>
  axios.get(`${API_BASE}/staff/client-requests`, { params });

export const approveClientRequest = (id) =>
  axios.put(`${API_BASE}/staff/client-requests/${id}/approve`, {});

export const rejectClientRequest = (id, reason) =>
  axios.put(`${API_BASE}/staff/client-requests/${id}/reject`, { reason });

export const completeClientRequest = (id) =>
  axios.put(`${API_BASE}/staff/client-requests/${id}/complete`, {});

// ─── Staff ────────────────────────────────────────────────────────────────────
// Source: logs → /staff/ (200 OK)
export const getStaffList = () =>
  axios.get(`${API_BASE}/staff/`);

// ─── Schedule / Events ───────────────────────────────────────────────────────
// Source: ScheduleView + EventDetailsPanel + logs → /schedule/events (200 OK)
export const getScheduleEvents = (date = null) =>
  axios.get(`${API_BASE}/schedule/events`, {
    params: date ? { date } : {},
  });

// Source: EventAuditLog.js
export const getEventAuditLog = (eventId) =>
  axios.get(`${API_BASE}/schedule/events/${eventId}/audit`);

export const deleteAuditLog = (eventId, auditId) =>
  axios.delete(`${API_BASE}/schedule/events/${eventId}/audit/${auditId}`);

// Source: EventActionModal.js
export const postEventAudit = (eventId, payload) =>
  axios.post(`${API_BASE}/schedule/events/${eventId}/audit`, payload);

export const updateEvent = (eventId, payload) =>
  axios.put(`${API_BASE}/schedule/events/${eventId}`, payload);

// ─── Invoices ─────────────────────────────────────────────────────────────────
// Source: logs → /invoices/ (200 OK)
export const getAllInvoices = (status = null) =>
  axios.get(`${API_BASE}/invoices/`, {
    params: status ? { status } : {},
  });

export const processPayment = (invoiceId, payload) =>
  axios.post(`${API_BASE}/invoices/${invoiceId}/payment`, payload);

// Source: MobileStaffInvoices.jsx
export const getRevenueStats = () =>
  axios.get(`${API_BASE}/invoices/stats/revenue`);

export const getOutstandingBalances = () =>
  axios.get(`${API_BASE}/invoices/stats/outstanding`);

// ─── Chat ─────────────────────────────────────────────────────────────────────
// Source: logs → /chat/rooms (200 OK)
export const getChatRooms = () =>
  axios.get(`${API_BASE}/chat/rooms`);

export const getChatMessages = (roomId) =>
  axios.get(`${API_BASE}/chat/rooms/${roomId}/messages`);

export const sendChatMessage = (roomId, message) =>
  axios.post(`${API_BASE}/chat/rooms/${roomId}/messages`, { message });

// ─── Alerts ───────────────────────────────────────────────────────────────────
// Source: logs → /alerts/channels/status (200 OK), /alerts/history (200 OK)
export const getAlertChannelsStatus = () =>
  axios.get(`${API_BASE}/alerts/channels/status`);

export const getAlertHistory = () =>
  axios.get(`${API_BASE}/alerts/history`);

export const sendAlert = (payload) =>
  axios.post(`${API_BASE}/alerts/send`, payload);

// ─── Fuel ─────────────────────────────────────────────────────────────────────
// Source: FuelView / useFuelData.js
export const getFuelInventory = () =>
  axios.get(`${API_BASE}/fuel/inventory`);

export const getFuelTransactions = (params = {}) =>
  axios.get(`${API_BASE}/fuel/transactions`, { params });

// Source: MobileMyTasks.jsx
export const getMyFuelRequests = () =>
  axios.get(`${API_BASE}/staff/fuel-requests/mine`);

export const updateFuelRequestStatus = (id, status, notes = '') =>
  axios.put(`${API_BASE}/staff/fuel-requests/${id}/status`, { status, notes });

export const logFuelDelivery = (requestId, deliveryData) =>
  axios.post(`${API_BASE}/staff/fuel-requests/${requestId}/delivery-log`, deliveryData);

// ─── Clients ──────────────────────────────────────────────────────────────────
// Source: ClientsView.js
export const getAllClients = () =>
  axios.get(`${API_BASE}/clients/`);

// Source: MobileStaffClients.jsx
export const getClientAircraft = (clientId) =>
  axios.get(`${API_BASE}/clients/${clientId}/aircraft`);

// ─── Aircraft ─────────────────────────────────────────────────────────────────
// Source: AircraftView.js
export const getAllAircraft = () =>
  axios.get(`${API_BASE}/aircraft/`);

// ─── Hangars ──────────────────────────────────────────────────────────────────
// Source: HangarsView.js
export const getAllHangars = () =>
  axios.get(`${API_BASE}/hangars/`);